import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { jobsKeys } from 'app/queries/jobs/jobsKeys';
import type { TCall } from 'app/queries/types/TCall';
import { requestWorkspaceJobs } from './requestWorkspaceJobs';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.workspaceList>>;

export const createFetchWorkspaceJobsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ workspaceId, params }], signal }: TParams) =>
    call(() => cancelOnSignal(requestWorkspaceJobs(workspaceId, params), signal));
